import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig } from "src/app/sharedinterfaces";

@Component({
	selector: "app-health-indicator",
	templateUrl: "./health-indicator.component.html",
	styleUrls: ["./health-indicator.component.scss"]
})
export class HealthIndicatorComponent implements OnChanges {
	@Input()
	hi: number;

	level: number;

	ngOnChanges() {
		if (this.hi !== null && typeof this.hi === "number") {
			this.level = this.hiToLevel(this.hi);
		} else {
			this.level = 0;
		}
	}

	hiToLevel(hi: number) {
		if (hi >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return 4;
		} else if (hi >= AssemblyConfig.HumsHiThreshold.Warning) {
			return 3;
			// } else if (hi >= AssemblyConfig.HumsHiThreshold.PreWarning) {
			//   return 2;
		} else {
			return 1;
		}
	}

	healthText() {
		switch (this.level) {
			case 4:
				return "Attention needed";
			case 3:
				return "Attention needed";
			case 2:
				return "Pre-warning...?";
			case 1:
				return "Normal Conditions";
			default:
				return "No Data";
		}
	}
}
